import { z } from "zod";

import { baseEntityFields } from "./base.js";

/**
 * Organisation (org) : l'instance cliente racine du multi-instance isolé.
 *
 * Étend les champs standard. `id` sert d'identifiant d'org (== `orgId`).
 *
 * - `name`    : nom de l'organisation.
 * - `slug`    : identifiant lisible (URL/sous-domaine), optionnel.
 * - `locale`  : langue par défaut (code BCP 47, ex. "en", "fr", "lb").
 * - `plan`    : forfait/offre de l'org, optionnel.
 */
export const OrganizationSchema = z.object({
  ...baseEntityFields,
  name: z.string().min(1),
  slug: z.string().min(1).optional(),
  locale: z.string().min(2).default("en"),
  plan: z.string().optional(),
});

/** Type d'une organisation. */
export type Organization = z.infer<typeof OrganizationSchema>;
